module.exports = __webpack_public_path__ + "components/page-footer/static/snow-icon-background-b9f9b7ea1e5f5c1c79c41c4263e4b1ae.svg";